import Layout from './components/Layout';
import ConfiguratorStep1 from './pages/configurator/ConfiguratorStep1';
import ConfiguratorStep2 from './pages/configurator/ConfiguratorStep2';
import ConfiguratorStep3 from './pages/configurator/ConfiguratorStep3';
import CustomerView from './pages/admin/CustomerView';
import CustomerDocument from './pages/admin/CustomerDocument';
import CustomerHistory from './pages/admin/CustomerHistory';
import CustomerRemarks from './pages/admin/CustomerRemarks';
import CustomerCosts from './pages/admin/CustomerCosts';
import CustomerCalculation from './pages/admin/CustomerCalculationOverview';
import CustomerImages from './pages/admin/CustomerImages';
import Inquiry from './pages/inquiry/Inquiry';
import Login from './pages/account/Login';
import ExternalLogin from './pages/account/ExternalLogin';
import CookieInfo from './pages/cookie/CookieInfo';
import CustomerConfigurations from './pages/admin/CustomerConfigurations';
import ResetPassword from './pages/account/ResetPassword';
import Profile from './pages/account/Profile';
import CustomerDocumentPrint from './pages/admin/CustomerDocumentPrint';
import CustomerTerms from './pages/admin/CustomerTerms';
import InquirySales from './pages/inquiry/InquirySales';
import InquiryUser from './pages/inquiry/InquiryUser';
import CustomerContact from './pages/admin/CustomerContact';
import ConfigurationDocuments from './pages/public/ConfigurationDocuments';
import Helper from './Helper';
import { Route, Redirect } from 'react-router-dom';
import { AnimatedSwitch } from 'react-router-transition';

const basename = process.env.REACT_APP_ROOT_PATH;

const renderExternalConfiguratorRoute = (Component: any, props: any) => {
	if (!Helper.userLoggedIn()) {
		return <Redirect to={`${basename}/login`} />;
	}
	return <Component {...props} isExternal={true} />;
};

const App = () => (
	<Layout>
		<AnimatedSwitch atEnter={{ opacity: 0 }} atLeave={{ opacity: 0 }} atActive={{ opacity: 1 }} className='switch-wrapper'>
			<Route exact path={`${basename}/configurator/selection*`} component={ConfiguratorStep1} />
			<Route exact path={`${basename}/configurator/configuration*`} component={ConfiguratorStep2} />
			<Route exact path={`${basename}/configurator/confirmation*`} component={ConfiguratorStep3} />

			<Route
				exact
				path={`${basename}/external-configurator/selection*`}
				render={(props: any) => renderExternalConfiguratorRoute(ConfiguratorStep1, props)}
			/>
			<Route
				exact
				path={`${basename}/external-configurator/configuration*`}
				render={(props: any) => renderExternalConfiguratorRoute(ConfiguratorStep2, props)}
			/>
			<Route
				exact
				path={`${basename}/external-configurator/confirmation*`}
				render={(props: any) => renderExternalConfiguratorRoute(ConfiguratorStep3, props)}
			/>

			<Route exact path={`${basename}/configurator/inquiry*`} component={Inquiry} />
			<Route exact path={`${basename}/configurator/inquirysales`} component={InquirySales} />
			<Route exact path={`${basename}/configurator/inquiryuser`} component={InquiryUser} />

			<Route exact path={`${basename}/admin`} component={CustomerView} />
			<Route
				exact
				path={`${basename}/admin/myProjects`}
				render={(props: any) => <CustomerView location={props.location} {...props} viewType={'my'} />}
			/>
			<Route
				exact
				path={`${basename}/admin/allProjects`}
				render={(props: any) => <CustomerView location={props.location} {...props} viewType={'all'} />}
			/>

			<Route exact path={`${basename}/admin/document/configurations`} component={CustomerConfigurations} />
			<Route exact path={`${basename}/admin/document/document`} component={CustomerDocument} />
			<Route exact path={`${basename}/admin/document/contact`} component={CustomerContact} />
			<Route exact path={`${basename}/admin/document/print`} component={CustomerDocumentPrint} />
			<Route exact path={`${basename}/admin/document/history`} component={CustomerHistory} />

			<Route exact path={`${basename}/admin/configuration/configurator`} component={CustomerCalculation} />
			<Route exact path={`${basename}/admin/configuration`} component={CustomerCalculation} />
			<Route
				exact
				path={`${basename}/admin/configuration/remarks`}
				render={(props: any) => <CustomerRemarks location={props.location} {...props} remarksType={'sales'} />}
			/>
			<Route
				exact
				path={`${basename}/admin/configuration/monter`}
				render={(props: any) => <CustomerRemarks location={props.location} {...props} remarksType={'monter'} />}
			/>
			<Route
				exact
				path={`${basename}/admin/configuration/position`}
				render={(props: any) => <CustomerRemarks location={props.location} {...props} remarksType={'position'} />}
			/>
			<Route exact path={`${basename}/admin/configuration/calculation`} component={CustomerCalculation} />
			<Route exact path={`${basename}/admin/configuration/costs`} component={CustomerCosts} />

			<Route exact path={`${basename}/admin/configuration/images`} component={CustomerImages} />
			<Route exact path={`${basename}/admin/document/terms`} component={CustomerTerms} />

			<Route exact path={`${basename}/login*`} component={Login} />
			<Route exact path={`${basename}/external-login*`} component={ExternalLogin} />
			<Route exact path={`${basename}/profile`} component={Profile} />
			<Route exact path={`${basename}/logout`} component={Login} />
			<Route exact path={`${basename}/reset*`} component={ResetPassword} />

			<Route exact path={`${basename}/cookie-info*`} component={CookieInfo} />

			<Route exact path={`${basename}/documents/:configurationId`} component={ConfigurationDocuments} />

			<Route exact path={`${basename}/*`} component={ConfiguratorStep1} />
		</AnimatedSwitch>
	</Layout>
);
export default App;
